/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var TemplateCellContainer = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TemplateCellContainer, _super);
    function TemplateCellContainer(a) {
        var _this = _super.call(this) || this;
        _this.d = null;
        _this._element = null;
        _this.b = null;
        _this.b = a;
        _this.element = a.createElement("div");
        return _this;
    }
    Object.defineProperty(TemplateCellContainer.prototype, "element", {
        get: function () {
            return this._element;
        },
        set: function (a) {
            this._element = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TemplateCellContainer.prototype, "isCanvasBased", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    TemplateCellContainer.$t = markType(TemplateCellContainer, 'TemplateCellContainer');
    return TemplateCellContainer;
}(Base));
export { TemplateCellContainer };
//# sourceMappingURL=TemplateCellContainer.js.map
